<template>
    <rkm-layout-body title="Lista de período contábil">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({name: 'web-service-almoxarifado-cliente-periodo-contabil-create'})"
                authorize="store-web-service-almoxarifado-cliente-periodo-contabil"
                color="primary"
            >
                Cadastrar período contábil
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/web-service/almoxarifado/cliente/periodo-contabil/List'

export default {
    components: {List},
}
</script>